export const getLocalizedPath = (
    path: string,
    pathname: string = window.location.pathname,
): string => {
    const normalizedPath = path.startsWith('/') ? path : `/${path}`;
    const locale = pathname.split('/').filter(Boolean)[0];

    if (locale === 'ja' || locale === 'en') {
        return `/${locale}${normalizedPath}`;
    }

    return normalizedPath;
};
